import React, { useEffect } from 'react';
import { reloadOnChunkLoadError } from '@/utils/chunkReload';

export default ({ error }: { error?: Error }) => {
  useEffect(() => {
    if (error) reloadOnChunkLoadError(error);
  }, [error]);
  return <div />;
};
